import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'components/common/FormElements/Input'

const StateEditor = ({ input, ...props }) =>
  <Input { ...props } input={ input } />

export default StateEditor

StateEditor.propTypes = {
  input: PropTypes.shape()
}

